import "./App.css";
import axios from "axios";
import React, { useState, useEffect } from "react";
import YouTubeIcon from "@mui/icons-material/YouTube";
import TwitterIcon from "@mui/icons-material/Twitter";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import DragHandleIcon from "@mui/icons-material/DragHandle";
import MenuIcon from "@mui/icons-material/Menu";

function App() {
  const [dataList, setDataList] = useState({
    faqListData: [],
    categoryData: [],
  });

  const fetchData = async (langID) => {
    let queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    let categoryID = urlParams.get("id");

    if (categoryID == null) {
      categoryID = 122;
    }
    if (langID == 1) {
      categoryID = 154;
    }

    let url = `https://m4newapi.seatech.com.tr/api/v1/FAQ/GetByCategoryID?id=${categoryID}`;

    await axios
      .get(url, {
        headers: {
          Authorization:
            "Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjIzNzQiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiQWxwZXIgU2F5ICIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL2VtYWlsYWRkcmVzcyI6ImFscGVyLnNheUB0b2dnLmNvbS50ciIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6IjEiLCJuYmYiOjE2OTAzMTM1NzAsImV4cCI6MjAwNTkzMjc3MCwiaXNzIjoiY2dEYXRhIiwiYXVkIjoiY2dEYXRhIn0.n_MM_9si_Chf5DH-arW2FKb8aqaHnTwHuzStEe-MQbc",
          "Content-Type": "aplication/json",
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((response) => {
        dataList.faqListData = response.data.data.faqList;
        dataList.categoryData = response.data.data;

        for (let i = 0; i < dataList.faqListData.length; i++) {
          let faq = dataList.faqListData[i];
          faq.imageUrl = faq.imageUrl.replace(
            "http://man.vas-cx.com",
            "https://m4newapi.seatech.com.tr"
          );
          if (faq.name.length > 60) {
            faq.name = faq.name.substring(0, 60) + "...";
          }
          if (faq.shortDesc.length > 60) {
            faq.shortDesc = faq.shortDesc.substring(0, 60) + "...";
          }
        }

        setDataList({
          faqListData: dataList.faqListData,
          categoryData: dataList.categoryData,
        });
      })
      .catch((error) => {
        console.log("status: " + error.response.status);
      });
  };
  let [dataLang, setDataLang] = useState({
    header: ["Dijital Kullanım Klavuzu", "Digital User Manual"],
    t10x: ["T10X'ini oluştur", "Create your T10X"],
    contact: ["Temas Noktaları", "Contact Points"],
    contactUse: ["Bize Ulaşın", "Contact Us"],
    about: ["Hakkımızda", "About Us"],
    career: ["Kariyer", "Career"],
    magazine: ["Basın", "Magazine"],
    partners: ["İş Ortaklarımız", "Work Partners"],
    togg: [
      "© 2021 Türkiye'nin Otomobili Girişim Grubu Sanayi ve Ticaret A.Ş. | Her hakkı saklıdır.",
      " © 2021 Türkiye'nin Otomobili Girişim Grubu Sanayi ve Ticaret A.Ş. | All rights reserved.",
    ],
    security: ["Güvenlik ve Gizlilik", "Privacy and Security"],
    dowloadButton: ["PDF İndir", "Download PDF"],

    lang: 0,
  });
  function saveByteArray(files) {
    if (files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        const downloadLink = document.createElement("a");

        downloadLink.title = files[i].name;
        downloadLink.download = files[i].name;
        downloadLink.href = files[i].filePath;
        downloadLink.target = "_blank";
        downloadLink.dispatchEvent(new MouseEvent("click"));
      }
    } else {
      alert("Dosya bulunamadı.");
    }
  }
  const [kategori, setKategori] = useState({
    kategori1: [],
  });

  const fetchData2 = async (langID) => {
    let projectID = 36;
    if (langID == 1) {
      projectID = 37;
    }
    let url = `https://m4newapi.seatech.com.tr/api/v1/KBCategory/MainList?projectId=${projectID}`;
    await axios
      .get(url, {
        headers: {
          Authorization:
            "Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjIzNzQiLCJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiQWxwZXIgU2F5ICIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL2VtYWlsYWRkcmVzcyI6ImFscGVyLnNheUB0b2dnLmNvbS50ciIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6IjEiLCJuYmYiOjE2OTAzMTM1NzAsImV4cCI6MjAwNTkzMjc3MCwiaXNzIjoiY2dEYXRhIiwiYXVkIjoiY2dEYXRhIn0.n_MM_9si_Chf5DH-arW2FKb8aqaHnTwHuzStEe-MQbc",
          "Content-Type": "aplication/json",
        },
      })
      .then((response) => {
        kategori.kategori1 = response.data.data;

        setKategori({
          kategori1: kategori.kategori1,
        });
      });
  };

  useEffect(() => {
    fetchData(0);
    fetchData2(0);
  }, []);

  return (
    <div className="App">
      <body>
        <nav class="navbar navbar-expand-lg bg-body-tertiary nav1">
          <div class="container-fluid nav2 ">
            <a
              class="navbar-brand togg"
              title="Togg"
              href="https://www.togg.com.tr/"
              target="_blank"
              dangerouslySetInnerHTML={{
                __html: `<img class="img-fluid togg" src="https://togg.seatech.com.tr/assets/Logo.png"></img>`,
              }}
            ></a>

            <button
              class="navbar-toggler togglerIcons"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span class="">
                <MenuIcon />
              </span>
            </button>
            {kategori.kategori1.map((item) => (
              <div
                class="collapse navbar-collapse test1"
                id="navbarSupportedContent"
              >
                <ul class="navbar-nav mb-6 mb-lg-0 test1">
                  <li class="nav-item">
                    <a class="nav-link " href={`/?id=${item.id}`}>
                      {item.name}
                    </a>
                  </li>
                </ul>

                <form class="language">
                  <button
                    class="btn btn-outline-light"
                    onClick={async (e) => {
                      if (dataLang.lang == 0) {
                        dataLang.lang = 1;
                      } else {
                        dataLang.lang = 0;
                      }
                      fetchData(dataLang.lang);
                      fetchData2(dataLang.lang);
                      setDataLang({
                        lang: dataLang.lang,
                        header: dataLang.header,
                        t10x: dataLang.t10x,
                        contact: dataLang.contact,
                        contactUse: dataLang.contactUse,
                        about: dataLang.about,
                        career: dataLang.career,
                        magazine: dataLang.magazine,
                        partners: dataLang.partners,
                        togg: dataLang.togg,
                        security: dataLang.security,
                        dowloadButton: dataLang.dowloadButton,
                      });
                      e.preventDefault();
                    }}
                  >
                    {dataLang.lang == 1 ? "TR" : "EN"}
                  </button>
                </form>
              </div>
            ))}
          </div>
        </nav>
        <div class="info">{dataLang.header[dataLang.lang]}</div>
        <div class="kartlar">
          <div className="information mt-5 mb-0 ">
            <p className="description">{dataList.categoryData.description}</p>
            <h5 className="isim ">{dataList.categoryData.name}</h5>
          </div>
        </div>

        <section class="row sec">
          {dataList.faqListData.map((item) => (
            <div class="card mb-3 baris">
              <div class="row g-0">
                <div
                  class="col-md-5"
                  dangerouslySetInnerHTML={{
                    __html: `<img class="img-fluid" src="${item.imageUrl}"></img>`,
                  }}
                ></div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h5 class="card-title">{item.name}</h5>
                    <p class="card-text mt-5 pt-5">{item.shortDesc}</p>
                    <p class="card-text mt-5 pt-5 ">
                      <buttıon
                        onClick={async () => {
                          saveByteArray(item.files);
                        }}
                        class="btn btn-primary btnPdf"
                      >
                        {dataLang.dowloadButton[dataLang.lang]}
                      </buttıon>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </section>

        <div class="d-flex flex-column h-100">
          <footer class="w-100 py-4 flex-shrink-0">
            <div class="container-fluid py-4">
              <div class="row gy-4 gx-5 mb-4">
                <div class="col-lg-7 col-md-6">
                  <h5 class="h1 text-white">
                    <a
                      class="navbar-brand togg2"
                      title="Togg"
                      href="https://www.togg.com.tr/"
                      target="_blank"
                      dangerouslySetInnerHTML={{
                        __html: `<img class="img-fluid togg2
                        " src="https://togg.seatech.com.tr/assets/Logo.png"></img>`,
                      }}
                    ></a>
                  </h5>
                </div>

                <div class="col-lg-3 col-md-6">
                  <h5 class="text-white mb-3"></h5>
                  <ul class="list-unstyled text-white">
                    <li>
                      <a
                        href="https://www.togg.com.tr/discovery"
                        target="_blank"
                        class="text-white"
                      >
                        T10X
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.togg.com.tr/order"
                        target="_blank"
                        class="text-white createt10x"
                      >
                        {dataLang.t10x[dataLang.lang]}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.togg.com.tr/trumore"
                        target="_blank"
                        class="text-white"
                      >
                        Trumore
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.togg.com.tr/contact-points"
                        target="_blank"
                        class="text-white"
                      >
                        {dataLang.contact[dataLang.lang]}
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.togg.com.tr/contact"
                        target="_blank"
                        class="text-white contact"
                      >
                        {dataLang.contactUse[dataLang.lang]}
                      </a>
                    </li>
                  </ul>
                </div>
                <div class="col-lg-2 col-md-6 links">
                  <h5 class="text-muted mb-4"></h5>
                  <ul class="list-unstyled text-white pt-3">
                    <li>
                      <a
                        href="https://www.togg.com.tr/about"
                        target="_blank"
                        class="text-white"
                      >
                        {dataLang.about[dataLang.lang]}
                      </a>
                    </li>
                    <li>
                      <a href="https://www.togg.com.tr/careers" target="_blank">
                        {dataLang.career[dataLang.lang]}
                      </a>
                    </li>

                    <li>
                      <a href="#!" class="text-white">
                        {dataLang.magazine[dataLang.lang]}
                      </a>
                    </li>
                    <li>
                      <a href="#!" class="text-white">
                        {dataLang.partners[dataLang.lang]}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="row gy-4 gx-5 line mt-0 pt-0 ">
                <div class="col-lg-8 col-md-6">
                  <div class="d-block">
                    <p class="small mb-2 text-white">
                      {dataLang.togg[dataLang.lang]}
                      <a class="text-primary" href="#"></a>
                    </p>
                  </div>
                </div>

                <div class="col-lg-4 col-md-6 ">
                  <form action="#">
                    <div class="mb-0 pt-0">
                      <li class="btn youtube" type="button">
                        <a
                          href="https://www.togg.com.tr/privacy-and-security"
                          target="_blank"
                        >
                          {dataLang.security[dataLang.lang]}
                        </a>{" "}
                        <i class="fas fa-paper-plane"></i>
                      </li>
                      <li class="btn youtube" type="button">
                        <a
                          href=" https://www.youtube.com/c/togg2022"
                          target="_blank"
                        >
                          <YouTubeIcon />
                        </a>
                      </li>
                      <li class="btn youtube" type="button">
                        <a
                          href="https://twitter.com/i/flow/login?redirect_after_login=%2Ftogg2022"
                          target="_blank"
                        >
                          <TwitterIcon />
                        </a>
                      </li>
                      <li class="btn youtube" type="button">
                        <a
                          href="https://www.instagram.com/togg2022/"
                          target="_blank"
                        >
                          <InstagramIcon />
                        </a>
                      </li>
                      <li class="btn youtube" type="button">
                        <a
                          href="https://www.linkedin.com/company/togg2022/"
                          target="_blank"
                        >
                          <LinkedInIcon />
                        </a>
                      </li>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </footer>
        </div>
      </body>
    </div>
  );
}

export default App;
